import list from 'src/modules/packagingCertification/list/packagingCertificationListReducers';
import form from 'src/modules/packagingCertification/form/packagingCertificationFormReducers';
import view from 'src/modules/packagingCertification/view/packagingCertificationViewReducers';
import destroy from 'src/modules/packagingCertification/destroy/packagingCertificationDestroyReducers';
import importerReducer from 'src/modules/packagingCertification/importer/packagingCertificationImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
